import { createContext, useContext, useEffect, ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSession } from '@client/model/selectors';
import { fetchFeatureFlagsRequest } from '@client/model/appConfigFeatureFlagsModel';
import { AppState } from '@client/model/store';

interface FeatureFlagsContextValue {
  flags: AppConfigFeatureFlags;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({
  flags: {},
});

export function FeatureFlagsProvider({ children }: { children: ReactNode }) {
  const dispatch = useDispatch();
  const { auth0Session } = useSelector(selectSession);
  const { flags, isLoading, isLoaded } = useSelector(
    (state: AppState) => state.appConfigFeatureFlags,
  );

  useEffect(() => {
    if (auth0Session?.accessToken && !isLoaded && !isLoading) {
      dispatch(fetchFeatureFlagsRequest());
    }
  }, [auth0Session?.accessToken, isLoaded, isLoading, dispatch]);

  return (
    <FeatureFlagsContext.Provider value={{ flags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
